// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormManageEntity } from '../../forms/FormManageEntity/FormManageEntity';

// types
import { Entity, EntityType } from '../../../@types';

// props
export interface DialogEditEntityProps {
	entity: Entity;
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
	type?: EntityType;
}

export const DialogEditEntity = ({
	entity,
	isOpen,
	onClose,
	onSuccess,
	type,
}: DialogEditEntityProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('saveEntity'),
					loading: isLoading,
					form: 'form-manage-entity',
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={550}
			onClose={onClose}
			title={{
				children: t('editEntity'),
				variant: 'h3',
			}}>
			<FormManageEntity
				entity={entity}
				onClose={onClose}
				onSuccess={onSuccess}
				setIsLoading={setIsLoading}
				type={type}
			/>
		</DialogActions>
	);
};
